(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoe-finder"] && !Shopify.designMode) return;
  try {
    
  function initShoeFinder(root) {
    if (!root || root.dataset.shoeFinderInit === 'true') return;
    root.dataset.shoeFinderInit = 'true';

    var state = { gender: null, usecase: null, groundfeel: null, experience: null };
    var options = root.querySelectorAll('[data-field]');
    var recommendations = root.querySelectorAll('[data-recommendation]');
    var placeholder = root.querySelector('[data-placeholder]');
    var fallback = root.querySelector('[data-fallback]');

    function select(field, value, skipRender) {
      var btn = root.querySelector('[data-field="' + field + '"][data-value="' + value + '"]');
      if (!btn) return;

      root.querySelectorAll('[data-field="' + field + '"]').forEach(function (sibling) {
        sibling.classList.remove('is-selected');
        sibling.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-checked', 'true');

      state[field] = value;
      if (!skipRender) render();
    }

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select(btn.getAttribute('data-field'), btn.getAttribute('data-value'));
      });
    });

    // Default selection on load: Men's / Running / Maximum ground feel
    select('gender', 'mens', true);
    select('usecase', 'running', true);
    select('groundfeel', 'maximum', true);
    select('experience', 'new', true);
    render();

    function render() {
      var haveCoreAnswers = state.gender && state.usecase && state.groundfeel;

      if (!haveCoreAnswers) {
        placeholder.hidden = false;
        fallback.hidden = true;
        recommendations.forEach(function (el) {
          el.hidden = true;
        });
        return;
      }

      placeholder.hidden = true;

      var matched = null;
      recommendations.forEach(function (el) {
        var isMatch =
          el.getAttribute('data-gender') === state.gender &&
          el.getAttribute('data-usecase') === state.usecase &&
          el.getAttribute('data-groundfeel') === state.groundfeel;

        el.hidden = !isMatch;
        if (isMatch) matched = el;
      });

      fallback.hidden = !!matched;

      if (matched) {
        var adviceNodes = matched.querySelectorAll('[data-advice]');
        adviceNodes.forEach(function (node) {
          node.hidden = node.getAttribute('data-advice') !== state.experience;
        });
      }
    }
  }

  function initAllShoeFinders(scope) {
    (scope || document).querySelectorAll('[data-shoe-finder]').forEach(initShoeFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllShoeFinders();
    });
  } else {
    initAllShoeFinders();
  }

  // Horizon / theme editor: re-run when a section is added or re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    initAllShoeFinders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
